import { useBrand } from "@/theme/context";

/**
 * The deployment's mark.
 *
 * When a client uploads a logo, tokens.json points at it and the file wins.
 * Otherwise this draws a mark from the accent tokens, so a fresh deployment
 * looks finished before anyone has supplied an asset — and a rebrand that only
 * changes colors still produces a correctly colored mark.
 */
export function BrandMark({ size = 32 }: { size?: number }) {
  const { logo, productName } = useBrand();

  if (logo) {
    return (
      <img
        src={logo}
        alt={productName}
        width={size}
        height={size}
        className="block object-contain"
        style={{ height: size }}
      />
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={productName}
      className="block shrink-0"
    >
      <rect width="32" height="32" rx="9" fill="var(--ming-accent)" />
      <circle cx="12.5" cy="16" r="6.5" fill="var(--ming-on-accent)" opacity="0.95" />
      <circle cx="20.5" cy="16" r="6.5" fill="var(--ming-on-accent)" opacity="0.45" />
    </svg>
  );
}

export function BrandLockup({ size = 32 }: { size?: number }) {
  const { productName } = useBrand();
  return (
    <span className="flex items-center gap-3">
      <BrandMark size={size} />
      <span className="type-h2 text-ink truncate">{productName}</span>
    </span>
  );
}
